import { Grid, LinearProgress } from '@material-ui/core'
import { Edit } from '@material-ui/icons'
import axios from 'axios'
import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { useSelector } from 'react-redux'

const ThumbnailUpload = ({
  setThumbnail,
  setThumbnailImage,
  thumbnailImage,
  defaultImage,
}) => {
  const [error, setError] = useState('')
  const [thumbnailUploading, setThumbnailUploading] = useState(false)

  const { userInfo } = useSelector((state) => state.userLogin)

  const handleThumbnailDrop = async (acceptedFile) => {
    const file = acceptedFile[0]
    const formData = new FormData()
    formData.append('image', file)
    setThumbnailUploading(true)

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const { data } = await axios.post('/api/thumbnail', formData, config)

      setThumbnail(data)
      setThumbnailImage(acceptedFile)
      setThumbnailUploading(false)
    } catch (err) {
      console.error(err)
      setThumbnailUploading(false)
      setError(err)
    }
  }

  return (
    <>
      <label htmlFor="part-thumbnail">Upload part thumbnail (optional)</label>

      <Grid container spacing={1}>
        <Grid item sm={6} style={{ height: 218 }}>
          <Dropzone
            onDrop={handleThumbnailDrop}
            className={error !== '' ? 'error' : ''}
          >
            {({ getRootProps, getInputProps, isDragActive }) => (
              <div
                {...getRootProps({
                  className: `dropzone tall thumbnail ${
                    thumbnailImage ? 'has-thumb' : 'no-thumb'
                  } ${isDragActive ? 'hovering' : ''}`,
                })}
              >
                <div className="dropzone-outer">
                  <div
                    className={`thumbnail-container ${
                      !thumbnailImage && 'no-thumbnail'
                    }`}
                    style={{
                      backgroundImage: `url(${
                        thumbnailImage ? thumbnailImage : defaultImage
                      })`,
                    }}
                  >
                    {thumbnailUploading && (
                      <div className="m-l-16 m-r-16">
                        <LinearProgress />
                      </div>
                    )}

                    <input {...getInputProps()} />
                  </div>

                  {!thumbnailUploading && <Edit className="icon" />}
                </div>
              </div>
            )}
          </Dropzone>
        </Grid>
        <Grid item sm={6} style={{ height: 218 }}>
          <p className="p-l-5 p-r-5 p-t-5">
            Drag and drop or click to add a thumbnail.
          </p>
        </Grid>
      </Grid>
    </>
  )
}

export default ThumbnailUpload
